import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as SystemAccessProfileService from '@/services/system-access-profile.service';

@Options({
  name: 'system-access-profile-new',
  components: {
    Toggle,
  },
})
export default class SystemAccessProfileNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row = {
    description: '',
    name: '',
    enabled: true,
  };

  public goBack() {
    this.$router.push('/system-access-profile');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.name) {
      this.errors.name = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }
    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      SystemAccessProfileService.insert({
        description: this.row.description,
        name: this.row.name,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/system-access-profile');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
